import type { ReactNode } from "react";

/*
 * THE ONE LOADING COMPONENT for app.* and book.*. Styles: shared/ui/loading.css,
 * imported once by each surface's entry. The sheen stops under
 * `prefers-reduced-motion: reduce`; the surface it runs on stays.
 */

/** Work in progress, announced once. No percentage is claimed. */
export function Working({ children }: { children: ReactNode }) {
  return (
    <div className="l-working" role="status" aria-live="polite">
      <span className="l-shimmer l-working-bar" aria-hidden="true" />
      <span className="l-working-text">{children}</span>
    </div>
  );
}

/**
 * One skeleton block. Purely decorative: the CALLER hides the group from
 * assistive technology and announces the loading state in its own words —
 * there is nothing to describe, and announcing grey rectangles would be worse
 * than silence.
 *
 * `contentful`: the block also draws itself as a block-sized inline SVG, which
 * makes it count for first-contentful-paint with no network (a plain
 * background does not). For a screen whose skeleton IS the first paint, such
 * as Book's boot skeleton (rc.12). The SVG is decorative: hidden, never
 * focusable, nothing in it to name. The sheen still runs over it.
 */
export function Skeleton({ w, h, r, contentful = false }: { w?: number | string; h: number | string; r?: number; contentful?: boolean }) {
  return (
    <span
      className="l-shimmer l-skel"
      style={{ width: w ?? "100%", height: h, borderRadius: r }}
    >
      {contentful ? (
        <svg width="100%" height="100%" aria-hidden="true" focusable="false" style={{ display: "block" }}>
          <rect width="100%" height="100%" style={{ fill: "var(--l-skeleton)" }} />
        </svg>
      ) : null}
    </span>
  );
}
